import { API_BASE_URL } from '../config/env';

async function chatwootFetch(path, options = {}) {
  const res = await fetch(`${API_BASE_URL}/api/chatwoot${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    },
    ...options
  });

  const text = await res.text();
  let json = null;
  try {
    json = text ? JSON.parse(text) : null;
  } catch {
    json = null;
  }

  if (!res.ok) {
    const err = new Error(json?.error || `Error ${res.status}`);
    err.status = res.status;
    err.details = json?.details;
    throw err;
  }

  if (res.status === 204) return null;
  return json;
}

export function fetchChatwootMeta() {
  return chatwootFetch('/meta');
}

export function fetchConversationTemplates(conversationId) {
  return chatwootFetch(`/conversations/${conversationId}/templates`);
}

export function sendConversationTemplate(conversationId, payload = {}) {
  return chatwootFetch(`/conversations/${conversationId}/template`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function fetchAssignmentAnalytics({ from, to, assigneeId, limit } = {}) {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  if (assigneeId) params.set('assignee_id', String(assigneeId));
  if (limit) params.set('limit', String(limit));
  const qs = params.toString();
  return chatwootFetch(`/assignments/analytics${qs ? `?${qs}` : ''}`);
}

export function fetchConversationsEstadoBulk(conversationIds = []) {
  const ids = [...new Set((conversationIds || []).map((id) => String(id).trim()).filter(Boolean))];
  if (!ids.length) return Promise.resolve({ data: {} });
  const qs = encodeURIComponent(ids.join(','));
  return chatwootFetch(`/conversations/estado?ids=${qs}`);
}

export function toggleConversationStatus(conversationId, { status, snoozed_until } = {}) {
  return chatwootFetch(`/conversations/${conversationId}/status`, {
    method: 'POST',
    body: JSON.stringify({
      status,
      ...(snoozed_until != null ? { snoozed_until } : {})
    })
  });
}

export function updateConversationPriority(conversationId, priority) {
  return chatwootFetch(`/conversations/${conversationId}/priority`, {
    method: 'PATCH',
    body: JSON.stringify({ priority })
  });
}

export function assignConversation(conversationId, payload) {
  return chatwootFetch(`/conversations/${conversationId}/assign`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function transferConversation(conversationId, payload) {
  return chatwootFetch(`/conversations/${conversationId}/transfer`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function requestHumanTakeover(conversationId, payload = {}) {
  return chatwootFetch(`/conversations/${conversationId}/human-takeover`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function requestHumanFinalize(conversationId, payload = {}) {
  return chatwootFetch(`/conversations/${conversationId}/human-finalize`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function requestHumanReturnToBot(conversationId, payload = {}) {
  return chatwootFetch(`/conversations/${conversationId}/human-return-to-bot`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function setConversationLabels(conversationId, labels) {
  return chatwootFetch(`/conversations/${conversationId}/labels`, {
    method: 'POST',
    body: JSON.stringify({ labels })
  });
}

export function deleteConversation(conversationId) {
  return chatwootFetch(`/conversations/${conversationId}`, { method: 'DELETE' });
}

export function buildChatwootConversationUrl(accountId, conversationId) {
  const base = (process.env.REACT_APP_CHATWOOT_APP_URL || 'https://chat.farmagsa.com.ar').replace(/\/$/, '');
  const acc = accountId || process.env.REACT_APP_CHATWOOT_ACCOUNT_ID || '1';
  return `${base}/app/accounts/${acc}/conversations/${conversationId}`;
}
